import BoolEditableCell from '../cells/bool-editable';
import { QueryTable } from '../query-table';

export type BooleanEditableBodyRender = {
  isInverted?: boolean;
  onChange?(id: string, value: boolean, refetch: () => void, rowData: any ): void;
};

export const booleanEditableBodyRender =
  (props: BooleanEditableBodyRender = { isInverted: false }) =>
  // eslint-disable-next-line react/display-name
  (value: boolean | null | undefined, { rowData }) => {
    const { loading, refetch } = QueryTable.useQueryTable();
    return (
      <BoolEditableCell
        loading={loading}
        value={props.isInverted ? !value : value}
        onChange={(id, value) =>
          props.onChange &&
          props.onChange(id, props.isInverted ? !value : value, refetch, rowData)
        }
        rowId={rowData.id}
      />
    );
  };
